import { MODEL_KEY } from '../../model/constants'
import { REMOTE_KEY_PREFIX } from '../../redux/constants'

export const MEAL_MODEL_CLASS_NAME = 'Meal'

export const MEAL_MODEL_KEY = {
  ...MODEL_KEY,

  NAME: 'name',
  NOTE: 'note',
  SUMMARY: 'summary',
  HEALTH_SCORE: 'healthScore',

  RECOMMENDED_AT: 'recommendedAt',
  LOGGED_AT: 'loggedAt',
  PLANNED_AT: 'plannedAt',

  CALORIE: 'calorie',
  PROTEIN: 'protein',
  CARBOHYDRATE: 'carbohydrate',
  FAT: 'fat',

  CALORIE_ESTIMATE: 'calorieEstimate',
  PROTEIN_ESTIMATE: 'proteinEstimate',
  CARBOHYDRATE_ESTIMATE: 'carbohydrateEstimate',
  FAT_ESTIMATE: 'fatEstimate',

  AI_RESPONSE: 'aiResponse',
  EDIT_RESULT_COUNT: 'editResultCount',

  SOURCE: 'source',
  SOURCE_TEXT: 'sourceText',

  // Associations
  FOODS: 'foods',
  HIGHLIGHTS: 'highlights',
  EDIT_RESULTS: 'editResults',
  MEDIA: 'media',
  PROFILE: 'profile',
  PLAN: 'plan',

  // Foreign
  PLAN_ID: 'planId',
  MEDIA_ID: 'mediaId',
  PROFILE_ID: 'profileId',

  // Remote -- understood by the server
  // Used for editing a meal using AI
  REMOTE_EDIT_RESULTS_DESCRIPTION: `${REMOTE_KEY_PREFIX}remoteEditResultsDescription`
}

export const MEAL_MODEL_PRIVATE_KEYS = []
export const MEAL_MODEL_ASSOCIATION_KEYS = [
  // No need to normalize that on the frontend
  // MEAL_MODEL_KEY.FOODS,
  MEAL_MODEL_KEY.MEDIA
]

export const MEAL_MODEL_SOURCE = {
  IMAGE: 'IMAGE',
  TEXT: 'TEXT',
  VOICE: 'VOICE'
}

export const MEAL_MODEL_SCOPE = {

  /**
   * Only returns the public attributes of the Post.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: MEAL_MODEL_PRIVATE_KEYS
    }
  }

}

export const MEAL_MODEL_AUDIT = {
  CREATED: 'Meal Created',
  UPDATED: 'Meal Updated',
  DELETED: 'Meal Deleted'
}

export const MAX_MEAL_EDIT_RESULTS_CREATED_COUNT_PER_DAY = 14
export const MAX_MEAL_CREATED_COUNT_PER_DAY = 21
